import 'slick-carousel';

/**
 * Go the the version based on the values of the inputs
 */
const goToVersion = (versions, $inputs) => {
    let selected = versions;
    $inputs.each(function() {
        selected = selected[$(this).val()];
    });
    if (typeof selected === 'string' && selected.indexOf('/') === 0) {
        window.location = selected;
    }
}

export default ($container) => {
    $('.js-product-detail', $container).slick({
        rows:     0,
        fade:     true,
        infinite: false,
        asNavFor: '.js-product-thumb',
    });

    $('.js-product-thumb', $container).slick({
        rows:          0,
        infinite:      false,
        arrows:        false,
        slidesToShow:  8,
        focusOnSelect: true,
        asNavFor:      '.js-product-detail',
        responsive:    [
            {
                breakpoint: 1200,
                settings:   {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 576,
                settings:   {
                    slidesToShow: 4,
                },
            },
        ],
    });

    $('.js-product-version-picker', $container).each(function() {
        const $picker  = $(this);
        const $inputs  = $(':input', $picker);
        const versions = $picker.data('versions');

        $inputs.on('change', function() {
            // TODO enable/disable options based on versions available
            goToVersion(versions, $('select, :input:radio:checked, :input:hidden', $picker));
        });
    });
};
